export default __webpack_public_path__ + "static/media/logical-grey.363286d3.png";